import { render, staticRenderFns } from "./GeneralSettingsTaxesBasedOnSource.vue?vue&type=template&id=6b9e6288&"
import script from "./GeneralSettingsTaxesBasedOnSource.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingsTaxesBasedOnSource.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports